var app = angular.module('leonardo');

var CategoryCacheRestService = function(CacheService, CategoryRestService) {
  var service = new BaseRestService('categories');
  
  service.getCategories = function() {
    return CacheService.getOrFetch('categories', function() {
      return CategoryRestService.getAll({ summary: true });
    });
  };

  return service;
};

app.factory('CategoryCacheRestService', ['CacheService', 'CategoryRestService', CategoryCacheRestService]);